export default __webpack_public_path__ + "static/media/craon9.74017133.jpg";